/**
 * EMZI NEXUS V6.3 - Mock Knowledge Packs
 * Dummy data for SOA Drill context (Product, Campaign, Compliance)
 * Will be replaced with real Knowledge Pack API later
 */

export const mockKnowledgePacks = {
  // Product Pack - 3 products
  products: [
    {
      id: "PROD_001",
      name: "Kopi Ala Kazim",
      category: "Health Beverage",
      usp: "Membantu menstabilkan gula darah secara semula jadi",
      description: "Kopi premium dengan campuran herba tradisional yang membantu mengawal tahap gula dalam darah.",
      target_audience: {
        age_group: "45-60",
        gender: "Wanita",
        interest: ["Kesihatan", "Herba", "Diabetes"]
      },
      compliance: {
        health_claims: ["Membantu menstabilkan", "Menyokong kesihatan"],
        prohibited_terms: ["Merawat diabetes", "Menyembuhkan"],
        approved: true
      },
      price: "RM89.00",
      promotion: {
        active: true,
        mechanic: "Beli 4 Percuma 1",
        urgency: "Terhad untuk 100 pelanggan pertama"
      }
    },
    {
      id: "PROD_002",
      name: "Serbuk Protein Muslimah",
      category: "Nutrition Supplement",
      usp: "Protein halal untuk wanita aktif",
      description: "Serbuk protein halal dengan kolagen dan vitamin khusus untuk keperluan wanita.",
      target_audience: {
        age_group: "25-40",
        gender: "Wanita",
        interest: ["Fitness", "Kesihatan", "Halal"]
      },
      compliance: {
        health_claims: ["Menyokong otot", "Membantu pemulihan"],
        prohibited_terms: ["Jamin kurus", "Hilang lemak"],
        approved: true
      },
      price: "RM129.00",
      promotion: {
        active: true,
        mechanic: "Diskaun 20% untuk pembelian pertama",
        urgency: "Tawaran sah hingga akhir bulan"
      }
    },
    {
      id: "PROD_003",
      name: "Minyak Zaitun Premium",
      category: "Cooking Oil",
      usp: "Minyak zaitun tulen dari Turki",
      description: "Minyak zaitun extra virgin berkualiti tinggi untuk masakan sihat keluarga.",
      target_audience: {
        age_group: "30-50",
        gender: "Campuran",
        interest: ["Masakan sihat", "Keluarga", "Premium"]
      },
      compliance: {
        health_claims: ["Sihat untuk jantung", "Kaya dengan antioksidan"],
        prohibited_terms: ["Rawat penyakit jantung"],
        approved: true
      },
      price: "RM68.00",
      promotion: {
        active: false,
        mechanic: "",
        urgency: ""
      }
    }
  ],

  // Campaign Pack - 3 campaigns
  campaigns: [
    {
      id: "CAMP_001",
      name: "Ramadan Sale 2025",
      objective: "Sales",
      theme: "Ramadan, Ibadah, Kesihatan",
      tone: "Islamik Mesra, Hangat",
      key_message: "Jaga kesihatan sambil beribadah dengan produk kami",
      target_emotion: "Ketenangan, Rasa prihatin",
      cta_guidance: "Dapatkan sekarang untuk Ramadan yang sihat",
      duration: "30 hari",
      budget: "RM50,000"
    },
    {
      id: "CAMP_002",
      name: "Women's Day Wellness",
      objective: "Awareness",
      theme: "Kesihatan wanita, Pemberdayaan",
      tone: "Profesional sopan, Inspiratif",
      key_message: "Wanita kuat bermula dengan kesihatan yang baik",
      target_emotion: "Inspirasi, Keyakinan",
      cta_guidance: "Ketahui lebih lanjut tentang produk kami",
      duration: "14 hari",
      budget: "RM30,000"
    },
    {
      id: "CAMP_003",
      name: "Family Health Bundle",
      objective: "Sales",
      theme: "Keluarga, Kesihatan, Value",
      tone: "Mesra, Prihatin",
      key_message: "Kesihatan seluruh keluarga dalam satu pakej",
      target_emotion: "Kasih sayang, Rasa bertanggungjawab",
      cta_guidance: "Jimat dengan pakej keluarga kami",
      duration: "60 hari",
      budget: "RM75,000"
    }
  ],

  // Compliance Pack
  compliance: {
    version: "V2.0",
    health_context: {
      allowed_claims: [
        "Membantu menstabilkan",
        "Menyokong",
        "Menggalakkan",
        "Memelihara",
        "Menjaga"
      ],
      prohibited_claims: [
        "Merawat",
        "Menyembuhkan",
        "Menghilangkan penyakit",
        "Menjamin",
        "100% berkesan"
      ],
      disclaimer_required: true,
      disclaimer_text: "Produk ini bukan untuk tujuan rawatan atau diagnosis penyakit. Sila rujuk doktor jika ada masalah kesihatan."
    },
    company_values: {
      core_values: ["Prihatin", "Amanah", "Hormat", "Ikhlas"],
      brand_voice: "Islamik Mesra - Lembut, sopan, penuh empati",
      prohibited_tone: ["Terlalu aggressive", "Menakut-nakutkan", "Memaksa"]
    },
    legal: {
      copyright_notice: "© 2025 EMZI Digital. Hak cipta terpelihara.",
      terms_acceptance: true,
      age_restriction: "18+",
      halal_certification: true
    }
  }
};

/**
 * Helper function to get random product
 */
export const getRandomProduct = () => {
  const products = mockKnowledgePacks.products;
  return products[Math.floor(Math.random() * products.length)];
};

/**
 * Helper function to get random campaign
 */
export const getRandomCampaign = () => {
  const campaigns = mockKnowledgePacks.campaigns;
  return campaigns[Math.floor(Math.random() * campaigns.length)];
};

/**
 * Helper function to build SOA context from Knowledge Packs
 */
export const buildSOAContext = (productId = null, campaignId = null) => {
  const product = productId
    ? mockKnowledgePacks.products.find(p => p.id === productId)
    : getRandomProduct();
  
  const campaign = campaignId
    ? mockKnowledgePacks.campaigns.find(c => c.id === campaignId)
    : getRandomCampaign();

  return {
    objective: campaign.objective,
    product: {
      name: product.name,
      usp: product.usp,
      target_audience: product.target_audience,
      compliance: product.compliance
    },
    campaign: {
      theme: campaign.theme,
      tone: campaign.tone,
      key_message: campaign.key_message,
      target_emotion: campaign.target_emotion,
      cta_guidance: campaign.cta_guidance
    },
    promotion: product.promotion,
    compliance: mockKnowledgePacks.compliance,
    brand_voice: mockKnowledgePacks.compliance.company_values.brand_voice
  };
};

export default mockKnowledgePacks;
